(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bg-video-with-text"] && !Shopify.designMode) return;
  try {
    
 $(document).on('click' , '.scroll_link' , function(){
   var getvalue = $(this).closest('.shopify-section').next();
   $("html, body").animate({ scrollTop: $(getvalue).offset().top }, 500);
 })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["default-video"] && !Shopify.designMode) return;
  try {
    
 $(document).on('click' , '.scroll_link' , function(){
   var getvalue = $(this).closest('.shopify-section').next();
   $("html, body").animate({ scrollTop: $(getvalue).offset().top }, 500);
 })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-overlay"] && !Shopify.designMode) return;
  try {
    
 $(document).on('click' , '.scroll_link' , function(){
   var getvalue = $(this).closest('.shopify-section').next();
   $("html, body").animate({ scrollTop: $(getvalue).offset().top }, 500);
 })

  } catch(e) { console.error(e); }
})();
})();
